export default "__VITE_ASSET__Bccaudeg__"